const safetyVANKeys = {
  all: ['SAFETY_VAN'],
  listData: () => [...safetyVANKeys.all, 'GET_LIST_DATA'],
  specificDataBase: () => [...safetyVANKeys.all, 'GET_SPECIFIC_DATA'],
  specificData: ({ seq }) => [...safetyVANKeys.specificDataBase(), seq],
};

export default safetyVANKeys;
